import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import preview_image from '../assets/consultations-preview.png';
import Modal from 'react-bootstrap/Modal'

import { NotificationsUtils, StringUtils, DateUtils, ArrayUtils } from '../utils';
import { Routes as routes, History as history } from '../navigation';
import { UserActions, NavigationActions, ContextActions, ConsultationsActions, PracticeActions } from '../actions';
import { SwitchAccount, TitleBar, Line, NavBar, ConsultationsResolved, SingleScreenNavBar, ConsultationsActive, ConsultationsProcessing, ConsultationsUnassigned, Header, Input } from  '../components'


class ConsultationsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_unassigned_tab: false,
      single_screen: false,
      jump_page: '',
      display_filter_modal: false,
      search_term: '',
      search_by: 'subject',
    }
  }

  componentDidMount() {
    this.props.contextActions.fetchDataForScreenAndRole('consultations');
    let is_front_desk = this.props.context && this.props.context.selectedRole && this.props.context.selectedRole === 'front_desk' ? true : false;
    if (is_front_desk) {
      this.setState({ ...this.state, single_screen: true });
    }
  }

  renderStatusSelectionButton = (status) => {
    let title = 'Active';
        title = status === 'RESOLVED' ? 'Resolved' : title;
        title = status === 'PROCESSING' ? 'Processing' : title;
        title = status === 'UNASSIGNED' ? 'Unassigned' : title;

    let header_title = title + ' Consultations';
    let badge_color  = status === 'PROCESSING' ? '#F71735' : '#1dc2ff';

    let selected_status = this.props.consultations && this.props.consultations.seeAllConsultationsStatus ? this.props.consultations.seeAllConsultationsStatus : 'ACTIVE';

    let selected = status === selected_status ? true : false;
    let color    = selected ? '#1dc2ff' : 'white';
    let txt_clr  = selected ? '#1dc2ff' : '';
    return <div className='selected-consultation-type-header flex-container-column'
                style={{ justifyContent: 'space-between', alignItems: 'center', height: 45 }}
                onClick={ () => { this.updateScreenStatus(status) }}>
      <div></div>
      <span className='flex-container-row' style={{ alignItems: 'center', fontSize: 12, fontWeight: 'bold', marginRight: 25, marginLeft: 25, color: txt_clr }}>
        { title.toUpperCase() }
      </span>
      <div style={{ height: 2, backgroundColor: color, width: '100%'}}></div>
    </div>
  }

  renderFooterBar = () => {
    let token = '';
    let page_state = this.props.consultations && this.props.consultations.seeAllConsultationsPageState ? this.props.consultations.seeAllConsultationsPageState : {};
    let arr        = this.props.consultations && this.props.consultations.seeAllConsultations ? this.props.consultations.seeAllConsultations : [];
    let current_page_num   = page_state && page_state.page_number ? page_state.page_number : 1;
    let display_next_btn   = arr.length === 0 ? false : true;
    let display_prev_btn   = current_page_num > 1 ? true : false;
    let page_number        = page_state.page_number;

    return <div className='flex-container-row' style={{ padding: 8, paddingLeft: 15, justifyContent: 'space-between', alignItems: 'center' }}>
      <div className='flex-container-row' style={{  }}>
        <Input  value={ this.state.jump_page }
                placeholder="#"
                className='input-default-border'
                style={{ fontSize: 13, width: 40, textAlign: 'center', marginRight: 5 }}
                onChange={ (event) => {
                  this.setState({ ...this.state, jump_page: event.target.value });
                }}
              />
        <span className='header-button'
              onClick={ () => {
                let page_num = parseInt(this.state.jump_page);
                this.props.consultationsActions.updateConsultationsScreenStatus('', page_num);
                this.setState({ ...this.state, jump_page: '' });
              }}>Page Jump</span>
      </div>
      <div className='flex-container-row' style={{ alignItems: 'center' }}>
        { display_prev_btn ? <div className='header-button'
                                  onClick={ () => {
                                    this.props.consultationsActions.updateConsultationsScreenStatus('', current_page_num - 1);
                                  }}>Previous</div> : null }
        <span style={{ marginRight: 12, marginLeft: 10 }}>{ page_number }</span>
        { display_next_btn ? <div className='header-button'
                                  onClick={ () => {
                                    this.props.consultationsActions.updateConsultationsScreenStatus('', current_page_num + 1);
                                  }}>Next</div> : null }
      </div>
    </div>
  }

  renderLabelRow = (status) => {
    let display_date = status === 'ACTIVE' || status === 'UNASSIGNED' ? true : false;
    let display_loc  = status === 'UNASSIGNED' ? true : false;
    let subject_perc = display_loc ? '45%' : '50%';
    let location_per = display_loc ? '20%' : '15%';
    return <div className='flex-container-column'>
      <div className='flex-container-row' style={{ paddingTop: 3, paddingBottom: 3 }}>
        <div style={{ width: subject_perc, color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', paddingLeft: 15 }}>SUBJECT</div>
        <div style={{ width: location_per, color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>{ display_loc ? 'LOCATION' : 'PROVIDER' }</div>
        <div style={{ width: '15%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>CLIENT</div>
        <div style={{ width: '10%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>PATIENT</div>
        <div style={{ width: '10%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>{ display_date ? 'CREATED' : 'RESOLVED AT' }</div>
      </div>
      <Line />
    </div>
  }

  renderConsultationRow = (consultation) => {
    let notificationsDict = this.props.notifications && this.props.notifications.notificationsConsultationsDict ? this.props.notifications.notificationsConsultationsDict : {};

    let client   = ArrayUtils.getSingleObject(consultation.client);
    let provider = ArrayUtils.getSingleObject(consultation.assignee);
    let patient  = ArrayUtils.getSingleObject(consultation.patient);
    let location = ArrayUtils.getSingleObject(consultation.location);
    let subject  = consultation.subject;
        subject  = subject.length > 70 ? subject.substr(0, 67) + '...' : subject;

    let provider_name= StringUtils.displayName(provider);
    let client_name  = StringUtils.displayName(client);
    let patient_name = StringUtils.displayName(patient);
    let created_date = DateUtils.getShortMonth(consultation.created_at) + ' ' + DateUtils.getDateNumber(consultation.created_at);
    let resolve_date = consultation.resolved_at ? DateUtils.getShortMonth(consultation.resolved_at) + ' ' + DateUtils.getDateNumber(consultation.resolved_at) : DateUtils.getShortMonth(consultation.updated_at) + ' ' + DateUtils.getDateNumber(consultation.updated_at);
    let date_str     = consultation.status === 'ACTIVE' ? created_date : resolve_date;
    let displayBadge = notificationsDict[consultation._id] ? true : false;
    let location_name= location.name ? location.name : '';
    let display_loc  = consultation.primary_assignee === 'unassigned' ? true : false;
    let subj_percent = display_loc ? '45%' : '50%';
    let loc_percent  = display_loc ? '20%' : '15%';
    let display_pending = consultation.status === 'PROCESSING' ? true : false;

    return <div key={consultation._id} className='flex-container-column'>
      <div className='flex-container-row standard-selection-row' style={{ paddingTop: 12, paddingBottom: 12 }} onClick={ () => { this.props.consultationsActions.openConsultation(this.props.token, consultation) }}>
        <div style={{ width: subj_percent, color: 'grey', paddingLeft: 15, fontSize: 13 }}>{ subject }</div>
        <div style={{ width: loc_percent,  color: 'grey', fontSize: 13 }}>{ display_loc ? location_name : provider_name }</div>
        <div style={{ width: '15%', color: 'grey', fontSize: 13 }}>{ client_name }</div>
        <div style={{ width: '10%', color: 'grey', fontSize: 13 }}>{ patient_name }</div>
        <div style={{ width: '10%', color: 'grey', fontSize: 13, alignItems: 'center', justifyContent: 'space-between' }} className='flex-container-row'>
          { !display_pending ? date_str : null }
          { display_pending  ? <span style={{ padding: 3, backgroundColor: '#e8f8ff', color: '#1dc2ff', fontWeight: 'bold', fontSize: 11, paddingRight: 11, paddingLeft: 11, borderRadius: 15 }}>Processing</span> : null }
          { displayBadge ? <span style={{ height: 6, width: 6, borderRadius: 3, backgroundColor: '#F71735', marginRight: 10 }}></span> : null }
        </div>
      </div>
      <Line style={{ backgroundColor: '#f5f5f5' }} />
    </div>
  }

  renderConsultationRows = () => {
    let display_consultations = this.props.consultations && this.props.consultations.seeAllConsultations ? this.props.consultations.seeAllConsultations : [];
    let status                = this.props.consultations && this.props.consultations.seeAllConsultationsStatus ? this.props.consultations.seeAllConsultationsStatus : 'ACTIVE';

    let consultation_rows = display_consultations.map((consultation) => {
      return this.renderConsultationRow(consultation);
    }).filter((row) => { return row });

    if (this.state.search_by === 'provider_name' && status === 'UNASSIGNED') {
      consultation_rows = [];
    }

    if (consultation_rows.length === 0) {
      let empty_message = 'There are no consultations to display';
          empty_message = status === 'RESOLVED' ? 'You have no resolved consultations...yet!' : empty_message;
      consultation_rows = <div className='flex-container-column' style={{ justifyContent: 'center', alignItems: 'center', marginTop: 40, marginBottom: 40, fontSize: 14, color: 'grey' }}>{ empty_message }</div>
    }

    return <div className='flex-container-column'>
      { this.renderLabelRow(status) }
      { consultation_rows }
    </div>
  }

  renderHeaderSection = (header_details) => {
    let page_state    = this.props.consultations && this.props.consultations.seeAllConsultationsPageState ? this.props.consultations.seeAllConsultationsPageState : {};
    let curr_s_term   = page_state && page_state.search_term ? page_state.search_term : '';
    let curr_s_by     = page_state && page_state.search_by   ? page_state.search_by   : '';
    let display_term  = curr_s_term && curr_s_by ? true : false;

    let search_by_label  = curr_s_by === 'subject'       ? 'Subject'       : '';
        search_by_label  = curr_s_by === 'provider_name' ? 'Provider Name' : search_by_label;
        search_by_label  = curr_s_by === 'client_name'   ? 'Client Name'   : search_by_label;
        search_by_label  = curr_s_by === 'patient_name'  ? 'Patient Name'  : search_by_label;

    return <div className='flex-container-row' style={{ justifyContent: 'space-between' }}>
      <Header title={header_details.header_title} icon={header_details.icon_class} iconColor={header_details.icon_color} line={false} />
      <div className='flex-container-row' style={{ alignItems: 'center', paddingRight: 10 }}>
        { display_term ? <div className='flex-container-row' style={{ alignItems: 'center' }}>
                           <div className='flex-container-column' style={{ marginRight: 10, justifyContent: 'center', alignItems: 'flex-end' }}>
                              <span style={{ fontSize: 13, color: '#575757' }}>{ curr_s_term     }</span>
                              <span style={{ fontSize: 10, color: '#1dc2ff', marginTop: -3 }}>{ search_by_label.toUpperCase() }</span>
                           </div>
                           <div className='button-outline'
                                onClick={ () => {
                                  this.props.consultationsActions.setConsultationSearchFilter('', '');
                                  this.setState({ ...this.state, search_term: '', search_by: 'subject' });
                                }}>
                               <span style={{  }}>Clear Filter</span>
                           </div>
                         </div>
                       : <div className='button-outline' onClick={ () => { this.setState({ ...this.state, display_filter_modal: true }) }}>
                           <span className='fas fa-search' style={{ marginRight: 8 }}/>
                           <span style={{ marginRight: 10 }}>Search & Filter</span>
                         </div> }
      </div>
    </div>
  }

  renderConsultationsInterface = () => {
    let practice          = this.props.practice && this.props.practice.info ? this.props.practice.info : null;
    let is_vet_or_behvrst = this.props.context && this.props.context.selectedRole && (this.props.context.selectedRole === 'vet' || this.props.context.selectedRole === 'behaviorist') ? true : false;
    let hide_unassigned   = practice && practice.provider_selection_disabled && practice.provider_selection_disabled === false ? true : false;
        hide_unassigned   = is_vet_or_behvrst ? true : hide_unassigned;
    let hide_processing   = is_vet_or_behvrst ? true : hide_unassigned;
    let header_details    = this.getHeaderDetails();
    let curr_practice     = this.props.practice && this.props.practice.practice ? this.props.practice.practice : {};
    let is_instant        = curr_practice && curr_practice.subscription && (curr_practice.subscription.subscription_type === 'INSTANT' || curr_practice.subscription.subscription_type === 'INSTANT_PAID');

    return <div className="flex-container screen-main-content" style={{ paddingTop: 15 }}>
        <div className='standard-container' style={{ width: '80%', maxWidth: 1000 }} >
          <div className='flex-container-row'>
            { this.renderStatusSelectionButton('ACTIVE')     }
            { hide_unassigned ? null : this.renderStatusSelectionButton('UNASSIGNED') }
            { this.renderStatusSelectionButton('RESOLVED')   }
            { hide_processing ? null : this.renderStatusSelectionButton('PROCESSING') }
          </div>
          <Line />
          { this.renderHeaderSection(header_details) }
          <Line />
          { this.renderConsultationRows() }
          <Line />
          { this.renderFooterBar() }
        </div>
      </div>
  }

  renderConsultationPreview = () => {
    return <div className='standard-container' style={{ width: 700, maxWidth: 700, minWidth: 700, flex: 1, marginTop: 25 }}>
      <div className='flex-container-column' style={{ padding: 15, alignItems: 'center' }}>
        <span style={{ fontWeight: 'bold', fontSize: 14, letterSpacing: 0.4, marginTop: 2, color: '#575757' }}>Available only to Professional and Enterprise plans</span>
        <div style={{ height: 2, backgroundColor: '#1dc2ff', width: 530, borderRadius: 10, marginTop: 5, marginBottom: 3 }}></div>
        <span style={{ fontSize: 13, letterSpacing: 0.4, color: '#1dc2ff', width: 540, paddingLeft: 5 }}>Your hub to seamlessly manage your practice’s consultations. Schedule appointments, bill clients, and automatically link data with your practice management system.</span>

        <div className='instant-join-session-button'
             style={{ marginTop: 15, marginBottom: 10, borderRadius: 30, paddingRight: 40, paddingLeft: 40 }}
             onClick={ () => {
               let screen_props = {
                 is_updgrade: true,
               }
               history.push({ pathname: routes.PRACTICE_PLANS, state: { props: screen_props } })
             }}>
          <span style={{ fontWeight: 'bold', fontSize: 14 }}>Upgrade</span>
        </div>

        <img className="instant-completed-preview-image" src={preview_image} alt="Icon Text" />

      </div>
    </div>
  }

  render() {
    let is_single_screen_display = this.state.single_screen;
    let display_section          = this.displayConsultationsSection();

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practice={this.props.practice.practice}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
        />
        { is_single_screen_display ? <SingleScreenNavBar title="All Consultations" />
                                   : <NavBar
                                       selectedPractice={this.props.context.selectedPractice}
                                       selectedRole={this.props.context.selectedRole}
                                       selectedTab={'my_account'}
                                       currentRoute={routes.CONSULTATIONS}
                                       practice={this.props.practice.practice}
                                       notifications={this.props.notifications}
                                     /> }

        { display_section ? this.renderConsultationsInterface() : null }
        { display_section ? null : this.renderConsultationPreview()    }
        { this.renderFilterModal()            }
      </div>
    );
  }

  displayConsultationsSection = () => {
    let practice        = this.props.practice && this.props.practice.practice ? this.props.practice.practice : {};
    let subscription    = practice && practice.subscription ? practice.subscription : {};
    let is_instant_paid = subscription.subscription_type === 'INSTANT_PAID';
    let is_core         = subscription.subscription_type === 'CORE';
    let is_enterprise   = subscription.subscription_type === 'ENTERPRISE';
    let display         = false;

    if (is_core || is_enterprise) {
      display = true;
    }

    return display;
  }

  renderFilterModal = () => {
    let display_modal = this.state.display_filter_modal;

    let is_subject  = this.state.search_by === 'subject';
    let is_provider = this.state.search_by === 'provider_name';
    let is_client   = this.state.search_by === 'client_name';
    let is_patient  = this.state.search_by === 'patient_name';

    let search_label = is_subject  ? 'Search Subject:'  : '';
        search_label = is_provider ? 'Search Provider:' : search_label;
        search_label = is_client   ? 'Search Client:'   : search_label;
        search_label = is_patient  ? 'Search Patient:'  : search_label;

    let placeholder  = is_subject  ? 'Enter Subject'       : '';
        placeholder  = is_provider ? 'Enter Provider Name' : placeholder;
        placeholder  = is_client   ? 'Enter Client Name'   : placeholder;
        placeholder  = is_patient  ? 'Enter Patient Name'  : placeholder;

    return <Modal show={display_modal} onHide={ () => { this.clearFilterModal() }}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row' style={{ marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold', fontSize: 16, marginTop: 2, color: '#575757' }}><span className='fas fa-search' style={{ marginRight: 5, color: '#1dc2ff' }} />Search & Filter Consultations</span>
          <span className='instant-cancel-button' onClick={ () => { this.clearFilterModal() }}>
            <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
          </span>
        </div>
        <div style={{ marginBottom: 5 }}>
          <span style={{ fontSize: 14, color: '#575757', marginLeft: 3 }}>Filter By:</span>
        </div>
        <div className='flex-container-row' style={{ alignItems: 'center' }}>
          <span className='button-outline' style={{ flex: 1, marginRight: 2, color: is_subject ? 'white' : '#1dc2ff', backgroundColor: is_subject ? '#1dc2ff' : 'white' }} onClick={ () => { this.setState({ ...this.state, search_by: 'subject' }) }}>Subject</span>
          <span className='button-outline' style={{ flex: 1, marginRight: 2, marginLeft: 2, color: is_provider ? 'white' : '#1dc2ff', backgroundColor: is_provider ? '#1dc2ff' : 'white' }} onClick={ () => { this.setState({ ...this.state, search_by: 'provider_name' }) }}>Provider</span>
          <span className='button-outline' style={{ flex: 1, marginRight: 2, marginLeft: 2, color: is_client   ? 'white' : '#1dc2ff', backgroundColor: is_client   ? '#1dc2ff' : 'white' }} onClick={ () => { this.setState({ ...this.state, search_by: 'client_name' }) }}>Client</span>
          <span className='button-outline' style={{ flex: 1, marginLeft: 2, color: is_patient  ? 'white' : '#1dc2ff', backgroundColor: is_patient ? '#1dc2ff' : 'white' }} onClick={ () => { this.setState({ ...this.state, search_by: 'patient_name' }) }}>Patient</span>
        </div>
        <div style={{ marginTop: 10, marginBottom: 5 }}>
          <span style={{ fontSize: 14, color: '#575757', marginLeft: 3 }}>{ search_label }</span>
        </div>
        <div className='flex-conatiner-row' style={{ }}>
          <Input placeholder={placeholder}
                 value={this.state.search_term}
                 className='instant-input-default'
                 style={{ width: '100%' }}
                 onChange={ (event) => { this.setState({ ...this.state, search_term: event.target.value }) }}
                />
        </div>
        <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'flex-end', marginTop: 10 }}>
          <div className='instant-cancel-button'
               style={{ marginRight: 5, color: '#1dc2ff', fontSize: 13 }}
               onClick={ () => {
                 this.setState({ ...this.state, search_term : '', display_filter_modal: false });
               }}>Cancel</div>
          <div className='instant-join-session-button'
               onClick={ () => {
                 if (this.state.search_term && this.state.search_by) {
                   this.props.consultationsActions.setConsultationSearchFilter(this.state.search_term, this.state.search_by);
                   this.setState({ ...this.state, display_filter_modal: false });
                 }
               }}>Apply</div>
        </div>
      </div>
    </Modal>
  }

  updateScreenStatus = (status) => {
    this.props.consultationsActions.getAllConsultations(status, 1);
  }

  getHeaderDetails = () => {
    let status = this.props.consultations && this.props.consultations.seeAllConsultationsStatus ? this.props.consultations.seeAllConsultationsStatus : 'ACTIVE';
    let consult_notifications_dict = this.props.notifications.notificationsConsultationsDict ? this.props.notifications.notificationsConsultationsDict : {};

    let header_title   = 'Active Consultations';
    let icon_class     = 'fa-notes-medical';
    let icon_color     = '#1dc2ff';

    if (status === 'RESOLVED') {
      header_title   = 'Resolved Consultations';
      icon_class     = 'fa-clipboard-check';
      icon_color     = '#66D56F';
    }

    if (status === 'UNASSIGNED') {
      header_title   = 'Unassigned Consultations';
      icon_class     = 'fa-clipboard';
      icon_color     = '#1dc2ff';
    }

    if (status === 'PROCESSING') {
      header_title   = 'Processing Consultations';
      icon_class     = 'fa-notes-medical';
      icon_color     = '#F71735';
    }

    return {
      header_title: header_title,
      icon_class: icon_class,
      icon_color: icon_color,
    }
  }

  getCurrentLocationId = () => {
    const frontDeskUsers = this.props.practice && this.props.practice.frontDeskUsers ? this.props.practice.frontDeskUsers : [];
    const currentUserId  = this.props.user.auth.user_id || '';
    const allLocations   = this.props.practice.locations || {};

    var current_location_id = null;

    if (frontDeskUsers.length > 0 && currentUserId) {
      frontDeskUsers.forEach((user) => {
        const locationID = user.location_id;
        const location   = allLocations[locationID];
        if (user.user_id === currentUserId) {
          current_location_id = location._id;
        }
      });
    }

    return current_location_id;
  }

  clearFilterModal = () => {
    this.setState({
      ...this.state,
      display_filter_modal: false,
      search_term: '',
      search_by: 'subject',
    });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    users: state.user.users,
    context: state.context,
    practice: state.practice,
    consultations: state.consultations,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultationsScreen)
